var render = function render(){var _vm=this,_c=_vm._self._c;return _c('base-tab-menu',{staticClass:"journey-tab-menu",attrs:{"type":"div","active-tab":_vm.localActiveTab,"tab-menu-items":_vm.tabMenuItems},on:{"input":function($event){_vm.localActiveTab = $event}}})
}
var staticRenderFns = []

export { render, staticRenderFns }